import type { Evidence } from "../../../domain/mapping";
import styles from "./MappingForm.module.css";

/** 구조화된 근거는 MCP와 JSON 편집에서 입력한다. 열람 시 적용 범위와 불확실성을 함께 보인다. */
export function EvidenceDetails({ label, evidence }: { label: string; evidence: Evidence }) {
  const search = {
    found: "공식 자료 확인",
    not_found_in_scope: "조사 범위에서 찾지 못함",
    not_investigated: "미조사",
    conflicting: "상충",
  }[evidence.official_search.status];
  return (
    <details>
      <summary>
        {label} 근거 · {evidence.basis ?? "미확인"} · {search}
      </summary>
      <p className={styles.caption}>
        근거의 자료·범위·추론은 JSON 편집 또는 MCP에서 입력합니다. 수치만 바꾸면 이전 검증과 검토는
        사용할 수 없습니다.
      </p>
      <dl>
        <dt>조사 범위</dt>
        <dd>{evidence.official_search.searched_locations.join(" · ") || "—"}</dd>
        <dt>조사 결과</dt>
        <dd>{evidence.official_search.summary ?? "—"}</dd>
        <dt>Revision · 손 · 역할</dt>
        <dd>
          {[evidence.scope.revision_uuid, evidence.scope.side, evidence.scope.role]
            .map((v) => v ?? "—")
            .join(" · ")}
        </dd>
        <dt>로봇 · 그리퍼</dt>
        <dd>
          {evidence.scope.robot_model ?? "—"} · {evidence.scope.gripper_model ?? "—"}
        </dd>
        <dt>기준 · 도구 프레임</dt>
        <dd>
          {evidence.scope.reference_frame ?? "—"} · {evidence.scope.tool_frame ?? "—"}
        </dd>
        <dt>장착 · 녹화 설정</dt>
        <dd>
          {evidence.scope.mounting ?? "—"} · {evidence.scope.recording_configuration ?? "—"}
        </dd>
        <dt>적용 범위와 한계</dt>
        <dd>{evidence.scope.applicability ?? "—"}</dd>
      </dl>
      {evidence.sources.map((source, index) => (
        <p key={index}>
          {source.locator} · {source.kind} · {source.authority} · {source.relation ?? "관계 미확인"}
          <br />
          {source.claim}
        </p>
      ))}
      {evidence.inference === null ? null : (
        <>
          <p>추론 방법: {evidence.inference.method ?? "—"}</p>
          {evidence.inference.alternatives.map((candidate, index) => (
            <p key={index}>
              다른 후보: {candidate.hypothesis} · {candidate.disposition} · {candidate.reason}
            </p>
          ))}
          {evidence.inference.checks.map((check, index) => (
            <p key={index}>
              {check.kind === "recorded" ? "실제 녹화" : "합성"} · {check.source_id} ·{" "}
              {check.clock_id} · {check.start_seconds}–{check.end_seconds}s · {check.sample_count}개
              <br />
              {check.finding}
            </p>
          ))}
          <p>자세 범위: {evidence.inference.orientation_coverage ?? "—"}</p>
          <p>식별 가능성: {evidence.inference.identifiability ?? "—"}</p>
          <p>남은 불확실성: {evidence.inference.uncertainty ?? "—"}</p>
        </>
      )}
    </details>
  );
}
